export default __webpack_public_path__ + "static/media/Maduro-4Open.c538c9f1.jpg";